import {searchRegistry} from "../../platform/search/register/search-registry";
import {FileClock, FileUser, FolderClock} from "lucide-react";

searchRegistry.register([
    {
        id: "employees.list",
        title: "Employee Management",
        description: "Manage Employees",
        route: "/employee/search",
        category: "Administration",
        permissions: ["ADMIN"],
        tags: ["employee", "list", "admin", "employee search"],
        icon: FileUser,
        type: 'quickLink'
    },
    {
        id: "employee.admin-attendance-card",
        title: "Employee Attendance",
        description: "Manage Employee Attendance",
        route: "/employee/attendance",
        category: "Administration",
        permissions: ["ADMIN"],
        tags: ["admin", "attendance"],
        icon: FileClock,
        type: 'result'
    }, {
        id: "my.admin-attendance-card",
        title: "My Attendance",
        description: "view admin-attendance-card",
        route: "/my/attendance",
        category: "UserAdministration",
        permissions: ["EMPLOYEE"],
        tags: ["attendance", "my", "clock", "time"],
        icon: FileClock,
        type: 'quickLink'
    }, {
        id: "allEmployees.list",
        title: "Employee List",
        description: "see organization employees",
        route: "/employee/search",
        category: "Administration",
        permissions: ["EMPLOYEE", "USER"],
        tags: ["employee", "list", "search"],
        icon: FileUser,
        type: 'result'
    },
    {
        id: "my.assets",
        title: "My Assets",
        description: "view Allocated assets",
        route: "/asset/allocation",
        category: "Administration",
        permissions: ["EMPLOYEE"],
        tags: ["allocate", "assets", "my"],
        icon: FolderClock,
        type: 'quickLink'
    },
    {
        id: "my.assets.request",
        title: "My Asset Requests",
        description: "view asset requests",
        route: "/asset/request",
        category: "Administration",
        permissions: ["EMPLOYEE"],
        tags: ["request", "assets", "my"],
        icon: FolderClock,
        type: 'quickLink'
    },
]);
